<template>
  <div>
    <!-- Search user by email -->
    <form @submit.prevent="onSubmit">
      <div class="header pt-3 blue-gradient">
          <mdb-row class="d-flex justify-content-center">
              <h4 class="white-text mb-3 pt-3"><i class="fas fa-search"></i> Search User By Email</h4>
          </mdb-row>
      </div>
      <div>
        <user-search-text-input></user-search-text-input>
      </div>
    </form>
    <br>

    <!-- Buttons to fetch data -->
    <div>
      <div class="header pt-2 blue-gradient">
        <mdb-row class="d-flex justify-content-center">
            <h5 class="white-text mb-3 pt-3"><i class="fas fa-search"></i> Select Button To Search By Criterion Indicated</h5>
        </mdb-row>
      </div>

      <div class="row d-flex justify-content-end">
        <button id="unverified-users" @click="fetchUserDetails('fetch-users', unverified_users, 'Unverified Users')"
                class="btn btn-outline-info btn-rounded" type="button">
          Unverified Users
        </button>

        <button id="unconfirmed-users" @click="fetchUserDetails('fetch-users', unconfirmed_users, 'Unconfirmed Users')"
                class="btn btn-outline-info btn-rounded" type="button">
          Unconfirmed Users
        </button>

        <button id="deactivated-users" @click="fetchUserDetails('fetch-users', deactivated_users, 'Deactivated Users')"
                class="btn btn-outline-info btn-rounded" type="button">
          Deactivated Users
        </button>

        <button id="deleted-users" @click="fetchUserDetails('fetch-users', deleted_users, 'Deleted Users')"
                class="btn btn-outline-info btn-rounded" type="button">
          Deleted Users
        </button>
      </div>
    </div>

    <user-accounts></user-accounts>
  </div>
</template>

<script>

import EventBus from '@/components/EventBus';
import {unverified_users, unconfirmed_users, deactivated_users, deleted_users, user_details} from "@/utils/api_paths";
import UserAccounts from "@/components/dashboard/UserAccounts";
import UserSearchTextInput from "@/components/dashboard/UserSearchTextInput";
import {mdbRow} from "mdbvue";


export default {
  name: "SystemAdmin", components: {UserSearchTextInput, UserAccounts, mdbRow},

  data (){
    return {
      unverified_users, unconfirmed_users, deactivated_users, deleted_users, user_details
    }
  },

  methods: {
    //fetching single user details
    onSubmit(){
      EventBus.$on('user-email', payload=> {
        /* Emit event that will be listened from UserAccounts component. In this event we shall also send email data
        * which will be required to identify the specific user. The Event being listened to here is from the
        * UserSearchInput component*/
        EventBus.$emit('fetch-users', {'path': user_details, 'email': payload, 'title': "User Details"})
      })
    },

    fetchUserDetails(eventName, path, componentTitle){
      /* Emit event that will be listened from UserAccounts component. The path to query will be required as the
      * buttons fetch different type of data, also pass the component title for appropriate labelling.*/
      EventBus.$emit(eventName, {'path': path, 'title': componentTitle})
    }
  }
}
</script>
